document.addEventListener('click', function (e) {
  const target = e.target.closest('.collection-item');
  if (!target) return;

  const selectedCollection = target.getAttribute('data-collection');
  document.querySelectorAll('.collection-item').forEach(i => i.classList.remove('active'));
  target.classList.add('active');

  document.querySelectorAll('.product-wrapper').forEach(product => {
    const productCollection = product.getAttribute('data-collection');
    product.style.display = productCollection === selectedCollection ? 'flex' : 'none';
  });
});